// eslint-disable-next-line @compiled/jsx-pragma
/** @jsxImportSource @compiled/react */
// `React` is imported and referenced (via React.FC) so this file works under the
// classic JSX runtime used by the Jest test env, while the pragma above enables
// the Compiled `css` prop for builds.
import * as React from 'react';
import { css } from '@compiled/react';
import type { HeadingProps } from '@atlaskit/heading';
import { token } from '@atlaskit/tokens';

export interface LabelHeadingProps {
	headingTag: NonNullable<HeadingProps['as']>;
	text: string;
}

// Visual reset for the semantic heading label: inherits the surrounding font
// and color and removes the browser's default heading margin/weight so the
// heading looks identical to the previous plain <span>.
const labelHeadingStyles = css({
	marginTop: token('space.0', '0'),
	marginRight: token('space.0', '0'),
	marginBottom: token('space.0', '0'),
	marginLeft: token('space.0', '0'),
	font: 'inherit',
	color: 'inherit',
});

// Renders the label text as a semantic heading element (e.g. h2) while keeping
// the visual appearance identical to the previous <span>: it inherits the
// surrounding font and color and resets the browser's default heading
// margin/weight so layout and styling are unchanged. The actual element
// (e.g. <h2>) is chosen via the `headingTag` prop.
export const LabelHeading: React.FC<LabelHeadingProps> = ({ text, headingTag: HeadingTag }) => (
	<HeadingTag css={labelHeadingStyles}>{text}</HeadingTag>
);
